/* src/app/main/pages/apps/container-vessel-tracker/container-vessel-tracker.component.css */
.app-img {
  width: 65px;
  height: 65px;
}
.back-link {
  color: #E8882D;
  font-family: "D-DIN";
  font-size: 16px;
}
.back-link .fa-angle-left {
  font-weight: 600;
}
.apps-form-input {
  background-color: #213654;
  padding: 8px 10px;
  margin-top: 30px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 6px #00000029;
}
.apps-form-input label {
  width: 18%;
  margin-bottom: 0px;
  font-weight: 600;
  padding-left: 17px;
}
.apps-form-input .form-control {
  font-size: 15px;
  border-radius: 0;
  padding: 3px 10px;
  border: none;
  width: 370px;
  height: 35px;
}
.bg-gray {
  background-color: #F5F5F5;
  box-shadow: 0px 3px 6px #00000029;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #E3EFFF;
}
tbody {
  background-color: #fff;
}
.table th,
.table td {
  padding: 8px 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  font-weight: 400;
}
@media (max-width: 768px) {
  .sm-border-none {
    border-right: none !important;
  }
  .bg-gray {
    margin-bottom: 30px;
  }
}
@media (max-width: 767px) {
  .apps-form-input label {
    width: 100%;
  }
  .apps-form-input label {
    margin-bottom: 10px;
  }
  .apps-form-input .form-control {
    width: 100%;
  }
  .btn-details {
    margin: 0 auto !important;
  }
  .bg-gray {
    margin-bottom: 30px;
  }
  .apps-form-input .form-group {
    text-align: center;
    width: 100%;
  }
  .apps-form-input {
    padding: 14px 10px;
  }
  .app-img {
    width: 60px;
    height: 60px;
    margin-top: 10px;
  }
  .table th,
  .table td {
    min-width: 32vw;
  }
  .apps-form-input {
    padding: 15px 10px;
  }
}
@media (device-width: 1024px) {
  .apps-form-input label {
    width: 24%;
  }
  .apps-form-input .form-control {
    width: 300px;
  }
  .border-after::after {
    right: 16px;
  }
}
@media (device-width: 1200px) {
  .border-after::after {
    right: 13px;
  }
}
@media (min-device-width: 1440px) and (max-device-width: 1599px) {
  .apps-form-input label {
    width: 20%;
    font-size: 17px;
  }
  .apps-form-input .form-control {
    font-size: 16px;
  }
  .table th,
  .table td {
    font-size: 19px;
  }
}
@media (min-width: 1440px) {
  .back-link {
    font-size: 24px !important;
  }
}
@media (min-width: 1600px) {
  .apps-form-input label {
    font-size: 18px;
    width: 17%;
  }
  .apps-form-input .form-control {
    font-size: 16px;
    padding: 6px 10px;
  }
  .back-link {
    font-size: 24px;
  }
  .container-vessel-tracker .table th,
  .container-vessel-tracker .table td {
    font-size: 20px;
  }
}
button.btn.btn-sm.btn-ornage {
  background-color: #E8882D;
  color: #fff;
}
.btn-details {
  background-color: #E8882D;
  border: none;
  color: #FFFFFF;
  border-radius: 0px;
  box-shadow: 0px 3px 6px #00000029;
  font-size: 14px;
  padding: 8px 36px;
  font-family: "D-DIN-Bold";
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
/*# sourceMappingURL=container-vessel-tracker.component.css.map */
